import React from 'react';
import ReactDOM from 'react-dom/client';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { Flip } from 'gsap/Flip';
import App from './App';
import './index.css';

// Register GSAP plugins
gsap.registerPlugin(useGSAP, Flip);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
